<template>
  <section class="section">
    <div class="container is-fluid">
      <div class="columns">
        <div class="column is-12">
          <h1 class="title is-3">📊 การพยากรณ์ (Forecasting)</h1>
        </div>
      </div>

      <div class="columns mt-4">
        <div class="column is-6">
          <FilterPanel />
          <HotspotTable />
        </div>
        <div class="column is-6">
          <TrendChart />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import FilterPanel from "@/components/FilterPanel.vue";
import HotspotTable from "@/components/HotspotTable.vue";
import TrendChart from "@/components/TrendChart.vue";
</script>
